import { useTranslation } from "react-i18next"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { object, string } from "yup"

export interface IMemberEmailRegistrationForm {
  type: string
  email: string
}

export function useEmailRegistrationForm() {
  const { t } = useTranslation()

  const schema = object({
    type: string().required(
      t("global.requiredField", {
        field: t("global.type_X", {
          entity: t("global.registration"),
          count: 0,
        }),
      })
    ),
    email: string()
      .required(t("auth.emailIsRequired"))
      .email(t("auth.invalidEmail")),
  }).required()

  return useForm<IMemberEmailRegistrationForm>({
    resolver: yupResolver(schema),
  })
}
